import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button'
import { IARDialog } from '../Dialog/IARDialog'
import Link from '@mui/material/Link'
import './PrepublishButtons.scss'
import CircularProgress from '@mui/material/CircularProgress'

const PrepublishButtons = ({
  savePreview = () => {},
  savePublish = () => {},
  isReadOnlyMember,
  disabledButton = false,
  isShown = false,
  discardChanges = () => {},
  closeDiscardDialog = () => {},
  isPreviewDialogOpen = false,
  isSaveDialogOpen = false,
  closeSaveDialog,
  isDiscardDialogOpen = false,
  closePreviewDialog,
  posting,
  openPreviewDialog = () => {},
  openDiscardDialog = () => {},
  publishButtonValidations = () => {},
  saveDialogCustomContent = undefined
}) => {
  const [savingPreview, setSavingPreview] = useState(false)
  const [savingPublish, setSavingPublish] = useState(false)

  const disableButtonsRef = useRef(false)
  disableButtonsRef.current = isReadOnlyMember || disabledButton

  useEffect(() => {
    if(!posting){
      setSavingPreview(false)
      setSavingPublish(false)
    }
  }, [posting])

  return (
    <div>
      {isShown ? ( //shown ? (
        (<>
          <IARDialog
            open={isSaveDialogOpen}
            title="Publish new content"
            content={saveDialogCustomContent || 'Do you want to publish new content?'}
            onOk={
              () => {
                setSavingPublish(true)
                savePublish()
              }
            }
            onCancel={closeSaveDialog}
          />
          <IARDialog
            open={isDiscardDialogOpen}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={() => {
              discardChanges()
              closeDiscardDialog()
            }}
            onCancel={closeDiscardDialog}
          />
          <IARDialog
            open={isPreviewDialogOpen}
            title="Save preview content for this section"
            content="Do you want to continue?"
            onOk={
              () => {
                setSavingPreview(true)
                savePreview()
              }
            }
            onCancel={closePreviewDialog}
          />
          <div className="prepublish-btns">
            <div className="save-prepublish-btn-container">
              <Button
                variant="contained"
                color="primary"
                className="prepublish-buttons-submit-button"
                size="medium"
                disabled={posting || disableButtonsRef.current}
                onClick={publishButtonValidations}
              >
                Publish
              {posting && savingPublish && <CircularProgress size={24} className="prepublish-buttons-progress-spinner-preview"/>}
              </Button>
              
            </div>
            <div className="save-prepublish-btn-container">
              <Button
                disabled={posting || disableButtonsRef.current}
                variant="outlined"
                color="primary"
                size="medium"
                onClick={openPreviewDialog}
                className="prepublish-buttons-preview-btn-prepublish"
              >
                Preview
                {posting && savingPreview && <CircularProgress size={24} className="prepublish-buttons-progress-spinner-preview"/>}
              </Button>
              
            </div>
            
            <div className="discard-prepublish">
              {isReadOnlyMember ? (
                <span className="cancelLinkDisabled">Discard last changes</span>
              ) : (
                <Link
                  className={ 
                    posting || disableButtonsRef.current
                    ? 'cancel-link-disabled'
                    : 'cancel-link'
                  }
                  onClick={disableButtonsRef.current ? () => {} : openDiscardDialog}
                >
                  Discard last changes
                </Link>
              )}
            </div>
          </div>
        </>)
      ) : null}
    </div>
  );
}

export default PrepublishButtons
